<mat-toolbar>
  <span>{{ 'FORM.CHECK_DETAILS' | transloco }}</span>
</mat-toolbar>
<div class="row">
  <div class="col">
    <mat-list>

      <h3 matSubheader>{{ 'FORM.NAME' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>person</mat-icon>
        <h4 matLine>{{userInput.customer.customer.firstname}} {{userInput.customer.customer.lastname}}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.PHONENUMBER' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>smartphone</mat-icon>
        <h4 matLine>{{userInput.customer.customer.cellular}}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>Email</h3>
      <mat-list-item>
        <mat-icon matListIcon>email</mat-icon>
        <h4 matLine>{{userInput.customer.customer.email}}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.PERSONS' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>people</mat-icon>
        <h4 matLine> {{
          (userInput.customer?.shuttles && userInput.customer?.shuttles[0] &&
          userInput.customer?.shuttles[0]?.passengers)
          ? userInput.customer?.shuttles[0]?.passengers
          : userInput.customer?.parking?.passengers
          }}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'SHUTTLE_PLANNING_PAGE.BAGGAGE' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>shop</mat-icon>
        <h4 matLine> {{
          (userInput.customer?.shuttles && userInput.customer?.shuttles[0] &&
          userInput.customer?.shuttles[0]?.baggage && userInput.customer?.shuttles[0]?.baggage == 1)
          ? 'Yes'
          : 'No'
          }}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.CARID' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>directions_car</mat-icon>
        <h4 matLine>{{ userInput.customer.parking.carId }}</h4>
      </mat-list-item>

      <mat-divider></mat-divider>

    </mat-list>
  </div>
  <div class="col">
    <mat-list>

      <h3 matSubheader>Organization</h3>
      <mat-list-item>
        <mat-icon matListIcon>business</mat-icon>
        <h4 matLine> {{ getOrganizationName(userInput.customer.order.organizationId) }}
        </h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.PARKING_FROM' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>local_parking</mat-icon>
        <h4 matLine>{{ userInput.customer.parking.parkingFrom | date : 'yyyy-MM-dd'}} {{ " " +
          ("PARKIFLY.CLOCK_SHORT" | transloco) }} {{
          userInput.customer.parking.parkingFrom | date : 'HH:mm'}}
        </h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      <h3 matSubheader>{{ 'FORM.PARKING_TO' | transloco }}</h3>
      <mat-list-item>
        <mat-icon matListIcon>local_parking</mat-icon>
        <h4 matLine>{{ userInput.customer.parking.parkingTo | date : 'yyyy-MM-dd'}} {{ " " +
          ("PARKIFLY.CLOCK_SHORT" | transloco) }} {{
          userInput.customer.parking.parkingTo | date : 'HH:mm'}}
        </h4>
      </mat-list-item>

      <mat-divider></mat-divider>

      @if (userInput.customer.order.organizationId?.toLowerCase() !== 'dc3e5c36-a4f7-4886-98f2-4833ea27f84b') {
      <div>
        <!-- Departure Info -->
        @if (userInput.customer.shuttles && userInput.customer.shuttles[0].flightnr) {
        <div>
          <h3 matSubheader>{{ 'FORM.DEPARTURE_FLIGHTNUMBER' | transloco }}</h3>
          <mat-list-item>
            <mat-icon matListIcon>flight_takeoff</mat-icon>
            <h4 matLine>{{ userInput.customer.shuttles[0].flightnr }} - {{
              userInput.customer.shuttles[0].flightdate | date : 'yyyy-MM-dd' }} {{ " " +
              ("PARKIFLY.CLOCK_SHORT" | transloco) }} {{
              userInput.customer.shuttles[0].flightdate | date : 'HH:mm' }}</h4>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        }
        @if (userInput.customer.shuttles && userInput.customer.shuttles[0].terminal &&
        !userInput.customer.shuttles[0].flightnr) {
        <div>
          <h3 matSubheader>{{ 'INTERNAL_BOOKING.HOTEL' | transloco }}</h3>
          <mat-list-item>
            <mat-icon matListIcon>hotel</mat-icon>
            <h4 matLine>{{ userInput.customer.shuttles[0].terminal }} - {{
              userInput.customer.shuttles[0].shuttledate | date : 'yyyy-MM-dd' }} {{ " " +
              ("PARKIFLY.CLOCK_SHORT" | transloco) }} {{
              userInput.customer.shuttles[0].shuttledate | date : 'HH:mm' }}</h4>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        }
        <!-- Arrival Info -->
        @if (userInput.customer.shuttles && userInput.customer.shuttles[1].flightnr) {
        <div>
          <h3 matSubheader>{{ 'FORM.ARRIVAL_FLIGHTNUMBER' | transloco }}</h3>
          <mat-list-item>
            <mat-icon matListIcon>flight_land</mat-icon>
            <h4 matLine>{{ userInput.customer.shuttles[1].flightnr }} - {{
              userInput.customer.shuttles[1].flightdate | date : 'yyyy-MM-dd' }} {{ " " +
              ("PARKIFLY.CLOCK_SHORT" | transloco) }} {{
              userInput.customer.shuttles[1].flightdate | date : 'HH:mm' }}</h4>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        }
        @if (userInput.customer.shuttles && userInput.customer.shuttles[1].terminal &&
        !userInput.customer.shuttles[1].flightnr) {
        <div>
          <h3 matSubheader>{{ 'INTERNAL_BOOKING.HOTEL' | transloco }}</h3>
          <mat-list-item>
            <mat-icon matListIcon>hotel</mat-icon>
            <h4 matLine>{{ userInput.customer.shuttles[1].terminal }} - {{
              userInput.customer.shuttles[1].shuttledate | date : 'yyyy-MM-dd' }} {{ " " +
              ("PARKIFLY.CLOCK_SHORT" | transloco) }} {{
              userInput.customer.shuttles[1].shuttledate | date : 'HH:mm' }}</h4>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>
        }
      </div>
      }

    </mat-list>
  </div>

  @if (userInput.customer.additionalServices && userInput.customer.additionalServices.length > 0) {
  <div class="row">
    <div class="col">
      <mat-list>
        <h3 matSubheader>{{ 'INTERNAL_BOOKING.ADDITIONAL_SERVICES' | transloco }}</h3>
        <mat-icon matListIcon class="margin-left-1rem-important">shopping_cart</mat-icon>
        @for (service of userInput.customer?.additionalServices; track service) {
        <mat-list-item>
          <h4 matLine>{{service.name[locale]}} - {{service.totalPrice}} SEK</h4>
        </mat-list-item>
        }
        <mat-divider></mat-divider>
      </mat-list>
    </div>
  </div>
  }
</div>

<div class="price-summary-card">
  <div class="price-row original-price">
    <span class="label">{{ 'PLACEHOLDER.BOOKING_PRICE' | transloco }}</span>
    <span class="value"
      [class.strikethrough]="userInput.customPrice !== null && userInput.customPrice !== undefined && userInput.customPrice != userInput.cart.totalPriceIncVat">{{
      userInput.cart.totalPriceIncVat }} SEK</span>
  </div>
  <div class="price-row custom-price">
    <span class="label font-weight-bold">{{ 'PLACEHOLDER.CHARGE_CUSTOMER' | transloco }}</span>
    <span class="badge custom-badge">{{ (userInput.customPrice !== null && userInput.customPrice !== undefined) ?
      userInput.customPrice : 0 }} SEK</span>
  </div>
</div>

<mat-action-list class="action-buttons-container">
  <button mat-raised-button type="button" class="button-size" (click)="cancel()" color="warn">
    <mat-icon class="mr-1">edit</mat-icon>
    {{ 'FORM.EDIT' | transloco | uppercase}}
  </button>

  <button mat-raised-button type="button" [disabled]="isLoading" (click)="sendConfirmation()"
    class="success-button button-size">
    @if (isLoading) {
    <mat-spinner color="accent" diameter="20"></mat-spinner>
    } @else {
    <mat-icon class="mr-1">check_circle</mat-icon>
    }
    {{ 'FORM.CONFIRM' | transloco | uppercase}}
  </button>
</mat-action-list>